import { useMemo } from 'react'
import {
  SharepointOptionsHelperResponse,
  SharePointOptions,
} from './SharepointFilePickerModal.types'

export const useSharepointOptionsHelper = (
  documentLibrary?: string,
  mode: 'files' | 'folders' = 'files',
  selectionMode: 'single' | 'multiple' = 'multiple',
): SharepointOptionsHelperResponse => {
  const options: SharePointOptions = useMemo(
    () => ({
      sdk: '8.0',
      entry: {
        sharePoint: {
          byPath: {
            fallbackToRoot: !documentLibrary,
            ...(documentLibrary ? { list: documentLibrary } : {}),
          },
        },
      },
      authentication: {},
      messaging: { origin: window.location.origin, channelId: '27' },
      typesAndSources: { mode: mode, pivots: { oneDrive: false } },
      selection: { mode: selectionMode },
      search: { enabled: true },
    }),
    [documentLibrary, mode, selectionMode],
  )

  const optionsQueryString = useMemo(
    () => new URLSearchParams({ filePicker: JSON.stringify(options) }),
    [options],
  )

  return { options, optionsQueryString }
}
